<template>
	<div 
		class="card-information" 
		@mouseover="mouseOver(data)"
		@mouseleave="mouseLeave(data)"
		v-if="data"
		:class="{'not-active': !data.active, 'active': data.active}">
		<div 
			class="text align-center"
			v-if="!visible"
			:style="`color:${$appColors.info}`"
			:class="{'opacity' : visible, 'not-opacity': !visible}">
			<v-layout>
				<v-flex xs3 class="center">
					<img :src="data.image" alt="">
				</v-flex>
				<v-flex xs9 ml-2 class="d-flex">
					<span>{{data.name}}</span>
				</v-flex>
			</v-layout>
		</div>
		<div
			class="information align-center"
			:class="{'opacity' : !visible, 'not-opacity': visible}"
		>
			<v-layout v-if="false">
				<v-flex xs4 d-flex align-center>
					<v-progress-circular
						:rotate="360"
						:size="40"
						:width="3"
						:value="data.percentage"
						color="#fff"
					>
						{{ data.percentage }}%
					</v-progress-circular>
				</v-flex>
				<v-flex xs8 pl-1>
					<v-layout class="wrapper-name">
						<v-flex xs3 ml-1 class="bold f-white">{{data.numApplicants}}</v-flex>
						<v-flex xs8 class="f-white text-small">Aplicantes</v-flex>
					</v-layout>
					<v-layout class="wrapper-name">
						<v-flex xs3 ml-1 class="bold f-white">{{data.numMale}}</v-flex>
						<v-flex xs8 class="f-white text-small">Masculino</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs3 ml-1 class="bold f-white">{{data.numFemale}}</v-flex>
						<v-flex xs8 class="f-white text-small">Femenino</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex
					xs12 caption
					class="card-information-description"
					:style="`color:${$appColors.info}`"
				>
					{{ data.description }}
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>
<script>
function data() {
	return {
		value: 0,
		interval: {},
		visible: false,
	};
}

function mouseOver({ active }) {
	if (active) {
		this.visible = true;
	}
}

function mouseLeave({ active }) {
	if (active) {
		this.visible = false;
	}
}

function visible(flag) {
	if (flag) {
		this.interval = setInterval(() => {
			if (this.value > Math.round(this.data.value * 100) / 100) {
				clearInterval(this.interval);
			} else {
				this.value = this.value;
			}
		}, 10);
	} else {
		this.value = 0;
	}
}

export default {
	name: 'card-information',
	data,
	methods: {
		mouseOver,
		mouseLeave,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
	watch: {
		visible,
	},
};
</script>
<style lang="scss" scoped>

	.card-information {
		position: relative;
		height: 85px;
		width: 100%;

		.text {
			background: map-get($colors, white);
			border-radius: 4px;
			border: 1px solid map-get($colors, border-gray);
			bottom: 0;
			display: flex;
			font-size: 11px;
			height: 100%;
			left: 0;
			padding: 0 8px;
			position: absolute;
			right: 0;
			top: 0;
			transition: all .2s ease-in-out;
		}

		.information {
			background-color: color(white);
			border-radius: 4px;
			border: 1px solid map-get($colors, border-gray);
			bottom: 0;
			display: flex;
			height: 100%;
			left: 0;
			padding: 0 7px;
			position: absolute;
			right: 0;
			top: 0;
			transition: all .2s ease-in-out;
		}

		.bold {
			font-family: map-get($fonts, bold);
			font-size: 12px;
		}

		.f-white {
			color: map-get($colors, white);
		}

		.text-small {
			font-size: 11px;
		}

		.wrapper-name {
			border-bottom: 1px solid map-get($colors, white);
		}

		.opacity {
			opacity: 0;
		}

		.not-opacity {
			opacity: 1;
		}

		&.not-active {
			opacity: 0.5;
		}

		&.active {
			cursor: pointer;
		}

		.center {
			align-items: center;
			display: flex;
			justify-content: center;
		}
	}

	.card-information-description {
		background-color: color(white);
		height: 83px;
		opacity: 1 !important;
		overflow: auto;
		position: relative !important;
		z-index: 1 !important;
	}
</style>




// WEBPACK FOOTER //
// src/components/diagnosis/card-information.vue